import React from 'react';

// Packages
import shortid from 'shortid';

const ProfileStatsBlock = ({ name, fields }) => (
  <div className={`profile-stats-block col-${fields.length}`} key={shortid.generate()}>
    <div className="profile-stats-block-header">
      <h3 className="profile-stats-block-header-heading">
        {name}
      </h3>
    </div>
    <div className="profile-stats-block-body">
      {fields.map((field) => {
        return (
          <div className="profile-stat-group" key={shortid.generate()}>
            <div className="profile-stat-group-heading">
              {field.abbreviation}
            </div>
            <div className="profile-stat-group-number">
              {field.value}
            </div>
          </div>
        );
      })}
    </div>
  </div>
)

export default ProfileStatsBlock;



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileStatsBlock.js